import { Icon } from '@/components/generic';
import { cn } from '@/lib/utils';

type ButtonBackProps = {
  className?: string;
  title: string;
  onClick?: () => void;
};
export const ButtonBack = ({ className, title, onClick }: ButtonBackProps) => (
  <button
    className={cn(
      `group inline-flex items-center h-14 mb-6 text-h5 text-t-primary md:h-10 md:text-sub-title-1 `,
      className,
    )}
    onClick={onClick}
    type='button'
  >
    <div className='flex justify-center items-center w-10 h-10 mr-3 '>
      <Icon
        className='fill-t-primary transition-transform group-hover:-translate-x-0.5 -rotate-135'
        name='arrow-up-right'
      />
    </div>
    <span className='text-h5'>{title}</span>
  </button>
);
